import PublicHttpClient from '../../services/public-http-client';
import { Pagination } from '../../../model/pagination';
import { ICommitmentPagedRequest } from '../../../model/sge/commitment/request/commitment-paged-request';
import { ICommitmentResponse } from '../../../model/sge/commitment/response/commitment-response';

const basePath = (clientId: number, amendmentId: number) => `Public/Client/${clientId}/Amendment/${amendmentId}/Commitments`;

const list = async (clientId: number, amendmentId: number, params: Omit<ICommitmentPagedRequest, 'amendmentId'>): Promise<Pagination<ICommitmentResponse>> => {
    return await PublicHttpClient.executeRequest({
        method: 'get',
        url: `/${basePath(clientId, amendmentId)}`,
        params
    }).then((response) => Object.assign(new Pagination<ICommitmentResponse>(), response.data));
};

const PublicCommitmentAppService = { list };
export default PublicCommitmentAppService;
